/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import toastr from '@/lib/notifications';
import $ from 'jquery';
import store from '../state/store';

store.on('enquiry:sms:create', function() {
  const state = store.get();

  const create_params = {
    enquiry_id: state.enquiry.id,
    content: state.ui.enquiry.smser.content
  };

  return $.ajax({
    url: "/api/sales/sms",
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(create_params),
    success: (data) => {
      store.get().ui.enquiry.smser.set({open: false, content: ''});
      toastr.success('Sms sent!');
      return store.emit('enquiry:comments:index', create_params.enquiry_id);
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

store.on('enquiry:sms:close', function() {
  store.get().ui.enquiry.smser.set({
    open: false,
    content: ''
  })
})

store.on('lead:sms:create', function() {
  const state = store.get();

  const create_params = {
    lead_id: state.lead.id,
    content: state.ui.lead.smser.content
  };

  return $.ajax({
    url: "/api/sales/sms",
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(create_params),
    success: (data) => {
      store.get().ui.lead.smser.set({open: false, content: ''});
      toastr.success('Sms sent!');
      return store.emit('lead:comments:index', create_params.lead_id);
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

store.on('lead:sms:close', function() {
  store.get().ui.lead.smser.set({
    open: false,
    content: ''
  })
})

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}